import { useQuery } from '@apollo/client/react';
import { GET_OPEN_TODOS_FOR_DATEPICKER } from './graphql/queries';

class OpenToDosForDatePicker {
  constructor({ date, hasOpenTodos }: { date: Date; hasOpenTodos: boolean }) {
    this.date = date;
    this.hasOpenTodos = hasOpenTodos;
  }
  date: Date;
  hasOpenTodos: boolean;
}

export function useOpenToDosForDatePicker(
  von: string,
  bis: string,
  standortId: string,
): {
  openToDosByDate: OpenToDosForDatePicker[];
  error: Error | undefined;
  loading: boolean;
} {
  const { data, error, loading } = useQuery(GET_OPEN_TODOS_FOR_DATEPICKER, {
    variables: { von, bis, standortId },
    fetchPolicy: 'cache-and-network',
  });

  const result =
    data?.findAllToDosForDatepicker?.map(
      (entry) =>
        new OpenToDosForDatePicker({
          date: new Date(entry.date),
          hasOpenTodos: entry.hasOpenToDos,
        }),
    ) || [];

  return {
    openToDosByDate: result,
    error: error,
    loading,
  };
}
